import { Box } from "@chakra-ui/react";
import React from "react";

export const OnboardingBreadCrumps = () => (
  <Box mb={8}>OnboardingBreadCrumps</Box>
);
